// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
import { oidcClientMetadataGuard, customClientMetadataGuard, roleNamesGuard, } from '../foundations/index.js';
import { ApplicationType } from './custom-types.js';
const createGuard = z.object({
    id: z.string().max(21),
    name: z.string().max(256),
    secret: z.string().max(64),
    description: z.string().nullable().optional(),
    type: z.nativeEnum(ApplicationType),
    oidcClientMetadata: oidcClientMetadataGuard,
    customClientMetadata: customClientMetadataGuard.optional(),
    roleNames: roleNamesGuard.optional(),
    createdAt: z.number().optional(),
});
const guard = z.object({
    id: z.string().max(21),
    name: z.string().max(256),
    secret: z.string().max(64),
    description: z.string().nullable(),
    type: z.nativeEnum(ApplicationType),
    oidcClientMetadata: oidcClientMetadataGuard,
    customClientMetadata: customClientMetadataGuard,
    roleNames: roleNamesGuard,
    createdAt: z.number(),
});
export const Applications = Object.freeze({
    table: 'applications',
    tableSingular: 'application',
    fields: {
        id: 'id',
        name: 'name',
        secret: 'secret',
        description: 'description',
        type: 'type',
        oidcClientMetadata: 'oidc_client_metadata',
        customClientMetadata: 'custom_client_metadata',
        roleNames: 'role_names',
        createdAt: 'created_at',
    },
    fieldKeys: [
        'id',
        'name',
        'secret',
        'description',
        'type',
        'oidcClientMetadata',
        'customClientMetadata',
        'roleNames',
        'createdAt',
    ],
    createGuard,
    guard,
});
